import _ from 'lodash'
import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { Nullable } from '@/types/general'
import { RevisionState, DiffedRevision, Revision } from './types'

const getters: GetterTree<RevisionState, RootState> = {
    diffedRevisions({ revisions }): DiffedRevision[] {
        if (revisions.length < 1) {
            return []
        }
        let prev = revisions[0]
        const diffedRevisions: DiffedRevision[] = []
        revisions.forEach((revision: Revision) => {
            const { title, tags, icon, content, ...meta } = revision
            if (!content) {
                console.warn('missing revision content for', title, meta.id)
                return
            }
            if (revision === prev) {
                if (revision.id === 0) {
                    diffedRevisions.push({
                        ...meta,
                        title,
                        tags,
                        icon,
                        diffs: {},
                        content,
                        message: 'Initial revision'
                    })
                }
                return
            }
            const diffs: any = {}

            if (title !== prev.title) {
                diffs.title = [prev.title, title]
            }
            if (tags !== prev.tags) {
                diffs.tags = [prev.tags, tags]
            }
            if (icon !== prev.icon) {
                diffs.icon = [prev.icon, icon]
            }
            Object.keys(content).forEach((key: string) => {
                if (content[key] !== prev.content[key]) {
                    diffs[key] = [prev.content[key], content[key]]
                }
            })

            diffedRevisions.push({ ...meta, title, tags, icon, diffs, content })
            prev = revision
        })
        return _.orderBy(diffedRevisions, 'id', 'desc')
    },

    previousRevision({ viewing }, { diffedRevisions: revisions }): Nullable<DiffedRevision> {
        if (!viewing || viewing.id === 0) {
            return null
        }
        return _.find(
            revisions, revision => revision.id === viewing.id - 1
        ) as DiffedRevision || null
    },

    nextRevision({ viewing }, { diffedRevisions: revisions }): Nullable<DiffedRevision> {
        if (!viewing) {
            return null
        }
        return _.find(
            revisions, revision => revision.id === viewing.id + 1
        ) as DiffedRevision || null
    }
}

export default getters
